import { styled } from '@mui/material/styles';
import { IconButton } from 'components/ui/IconButton';
import { getZoomAdjustedThemeSpacingPx } from 'components/ui/utilities/theme';
import { getZoomAdjustedPx } from 'components/ui/utilities/zoom';

interface FolderActionsRootStyleProps {
  isMenuOpen?: boolean;
  zoomLevel: number;
}

const shouldForwardRootProp = (prop: PropertyKey) => prop !== 'isMenuOpen' && prop !== 'zoomLevel';

export const FirmDocumentFolderActionsRoot = styled('div', {
  shouldForwardProp: shouldForwardRootProp,
})<FolderActionsRootStyleProps>(({ isMenuOpen = false, theme, zoomLevel }) => ({
  '--icon-button-compact-icon-size': getZoomAdjustedPx(16, zoomLevel),
  '--icon-button-compact-size': getZoomAdjustedPx(20, zoomLevel),
  '--icon-button-radius': getZoomAdjustedPx(theme.shape.radius.xs, zoomLevel),
  '--firm-document-folder-actions-gap': getZoomAdjustedThemeSpacingPx(theme, 'xs', zoomLevel),
  alignItems: 'center',
  display: 'inline-flex',
  flex: '0 0 auto',
  gap: 'var(--firm-document-folder-actions-gap)',
  minWidth: 0,
  opacity: isMenuOpen ? 1 : 0,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const FirmDocumentFolderActionTrigger = styled(IconButton)(({ theme }) => ({
  '&:focus-visible': {
    boxShadow: `0 0 0 1px ${theme.palette.brand[400]}`,
    outline: 0,
  },
}));
